import { Formik, Field } from 'formik';
import React from 'react';
import Form from '@lt/components/components/Form';
import { RatingSelector } from 'src/routes/TestimonialsForm/components/RatingSelector';
import {
  contentIsEmpty,
  contentLength,
  getCommentFormFieldsToFill,
  testimonialsFormValidate,
} from 'src/routes/TestimonialsForm/utils';
import { CONTENT_MIN_LENGTH } from 'src/routes/TestimonialsForm/constants';
import classnames from 'classnames';
import type { TestimonialsFormValues } from '../../types';

type Props = {
  onSubmit: (values: TestimonialsFormValues) => Promise<void>;
  initialValues?: TestimonialsFormValues;
};

const defaultInitialValues: TestimonialsFormValues = {
  title: '',
  content: '',
  order_id: undefined,
  tour_selection: undefined,
  booking_simplicity: undefined,
  usability: undefined,
};

export const TestimonialsForm = ({ onSubmit, initialValues }: Props) => (
  <Formik<TestimonialsFormValues>
    validationSchema={testimonialsFormValidate}
    initialValues={initialValues || defaultInitialValues}
    onSubmit={onSubmit}
  >
    {({ values, handleSubmit, isValid }) => {
      const commentFormFieldsToFill = getCommentFormFieldsToFill(values);
      return (
        <div className="testimonial_create">
          <div className="testimonial_form">
            <h3>Ваши впечатления помогают нам и другим туристам</h3>
            <div className="comment_form">
              <form onSubmit={handleSubmit}>
                <div className="comment_form_wrapper">
                  <div className="comment_form_left">
                    <div className="comment_form_block">
                      <h4>Заголовок вашего отзыва</h4>
                      <Form.Input
                        placeholder="Впечатление от сервиса в целом"
                        type="text"
                        name="title"
                      />
                    </div>
                    <div className="comment_form_block">
                      <h4>
                        Ваш отзыв
                        <span
                          className={classnames('chars_left', {
                            passed: !contentIsEmpty(values),
                          })}
                        >
                          {' '}
                          {contentLength(values)} символов (минимум{' '}
                          {CONTENT_MIN_LENGTH})
                        </span>
                      </h4>
                      <Form.Textarea
                        placeholder="Напишите что понравилось в процессе выбора и заказа тура, как онлайн бронирование отличается от похода в агентство, что могло бы помочь вам сделать выбор быстрее и удобнее"
                        name="content"
                      />
                    </div>
                    <div className="comment_form_block comment_rating">
                      <h4>Оцените использование сервиса</h4>
                      <ul className="comment_rating_stars">
                        <Field
                          component={RatingSelector}
                          label="выбор туров на сайте"
                          name="tour_selection"
                        />
                        <Field
                          name="booking_simplicity"
                          label="простота покупки"
                          component={RatingSelector}
                        />
                        <Field
                          name="usability"
                          label="общее удобство сервиса"
                          component={RatingSelector}
                        />
                      </ul>
                    </div>
                  </div>
                </div>
                {commentFormFieldsToFill && (
                  <div
                    className={classnames('comment_form_fields_to_fill', {
                      passed: isValid,
                    })}
                  >
                    {commentFormFieldsToFill}
                  </div>
                )}
                <div className="comment_form_submit">
                  <button
                    type="submit"
                    className="stylized"
                    disabled={!isValid}
                  >
                    Отправить
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      );
    }}
  </Formik>
);
